import { Component } from '@angular/core';
import { User } from '../models/user';
import { AuthService } from '../services/authService';
import { retryWhen, switchMap, of, delay, catchError } from 'rxjs';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss',
    standalone: false
})
export class FooterComponent {
  user = new User('', false);

  constructor(private authService: AuthService) { }

  async ngOnInit() {
    const isLoggedIn = await this.checkIfUserIsLoggedIn();
  }

  // Todo: write sad path unit tests for this method
  // Todo: write happy path unit tests for this method
  private checkIfUserIsLoggedIn(): Promise<boolean> {
    return new Promise((resolve) => {
      this.authService.isLoggedIn().pipe(
        retryWhen(errors =>
          errors.pipe(
            switchMap((error) => {
              console.error('Error occurred:', error.message);
              // Retry only if the error status is 500
              if (error.status === 500) {
                return of(error).pipe(delay(1000));
              }
              // If the error is not 500, throw the error
              throw error;
            })
          )
        ),
        catchError((error) => {
          console.error('Final error after retries:', error);
          return of({ isAuthenticated: false, userName: '' });
        })
      ).subscribe((response: any) => {
        this.user.loggedin = response.isAuthenticated;
        this.user.username = response.userName ?? "";
        resolve(this.user.loggedin);
      });
    });
  }
}
